import { ArrowSquareUp } from "iconsax-reactjs";
import { DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE } from "@/constants/diagnostics";
import { selectDiagnosticsStep } from "@/store/features/diagnostics/selectors";
import { setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { StyledArrow, StyledArrows, StyledPlaceholder } from "./styled";

const Arrows = () => {
  const step = useAppSelector(selectDiagnosticsStep);
  const dispatch = useAppDispatch();

  const onClickUp = () => {
    let value = step - 1;

    if (value === DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE) {
      value -= 1;
    }

    dispatch(setDiagnosticsStep(value));
  };

  return (
    <StyledArrows>
      {step > 0 ? (
        <StyledArrow onClick={onClickUp}>
          <ArrowSquareUp size="44" color="var(--color-text-60)"/>
        </StyledArrow>
      ) : (
        <StyledPlaceholder />
      )}
    </StyledArrows>
  );
};

export default Arrows;